import { getProxiedUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class AuthorisedUserService {
    static createAuthorisedUserExt(params, authHeader = {}) {
        return JsonRPCService.send(getProxiedUrl('authorized_user'),
            'createAuthorisedUser', [params], authHeader);
    }

    static isEffectiveUserAnAuthorisedUser(authHeader = {}) {
        return JsonRPCService.send(getProxiedUrl('authorized_user'),
            'isEffectiveUserAnAuthorisedUser', [], authHeader);
    }

    static getActiveAuthorisedUser(authHeader = {}) {
        return JsonRPCService.send(getProxiedUrl('authorized_user'),
            'getActiveAuthorisedUser', [], authHeader);
    }

    static deActivateAuthorisedUser(params, authHeader = {}) {
        return JsonRPCService.send(getProxiedUrl('authorized_user'),
            'deActivateAuthorisedUser', [params], authHeader);
    }
}
